<script>
import * as acessomodulo from '@/api/acessomodulo'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  data () {
    return {
      backend: acessomodulo
    }
  },
  methods: {
    refresh (data) {
      return this.$refs.form.setData(data)
    }
  }
}
</script>

<template>
  <simple-crud-form ref="form" :mode="mode" @cancel="(data) => $emit('cancel', data)" @save="(data) => $emit('save', data)" :backend="backend" />
</template>
